module.exports = __webpack_public_path__ + "static/img/manual-9.eeffdb7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-9.png
// module id = IsFa
// module chunks = 4